import { render, staticRenderFns } from "./Remessas.vue?vue&type=template&id=456ef144&scoped=true"
import script from "./Remessas.vue?vue&type=script&lang=js"
export * from "./Remessas.vue?vue&type=script&lang=js"
import style0 from "./Remessas.vue?vue&type=style&index=0&id=456ef144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ef144",
  null
  
)

export default component.exports